module.exports = __webpack_public_path__ + "static/media/playstore.f0bfa939.png";